/* SCC immersive layer: reveal on scroll, tilt + glare on deck tiles, pointer light on dark panels,
   drifting suits behind the hero, a Play link in the header, scroll progress. Display only, no dependencies. */
(function () {
  'use strict';
  if (window.__sccImm) return;
  window.__sccImm = true;
  var doc = document.documentElement;
  doc.classList.add('scc-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var games = (window.SCC && window.SCC.gamesUrl) || '/pages/games';

  /* ---------- reveal on scroll (deck grids are left alone: Find your deck animates its own filtering, and
     revealing each tile as it scrolled in made the grid flash) ---------- */
  var RV = [
    '.scc-ch-intro .page-width > *', '.scc-ch-outro .page-width > *',
    '.scc-fd__head > *', '.scc-ga__head > *', '.scc-ga__list > li',
    '.scc-gs__copy > *', '.scc-club__pillar', '.scc-club__join > *', '.scc-more .page-width > *',
    '.product-tabs-wrapper', '.main-page-title', '.collection-hero__inner > *',
    '.scc-games__head > *', '.scc-games__pick', '.scc-games__how > *'
  ].join(',');
  function markReveal(scope) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = [].slice.call((scope || document).querySelectorAll(RV));
    var io = markReveal.io || (markReveal.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); markReveal.io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }));
    els.forEach(function (el) {
      if (el.classList.contains('scc-rv')) return;
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return; /* already on screen: leave it be */
      var sibs = el.parentNode ? [].indexOf.call(el.parentNode.children, el) : 0;
      el.style.setProperty('--rv-d', Math.min(sibs, 6) * 0.07 + 's');
      el.classList.add('scc-rv');
      io.observe(el);
    });
  }

  /* ---------- tilt + glare ---------- */
  function tilt(scope) {
    if (!fine || reduce) return;
    [].forEach.call((scope || document).querySelectorAll('.scc-fd__media, .scc-ga__tile'), function (el) {
      if (el.__tilt) return; el.__tilt = true;
      el.classList.add('scc-tilt');
      if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
      var g = document.createElement('i'); g.className = 'scc-tilt__glare'; g.setAttribute('aria-hidden', 'true'); el.appendChild(g);
      var raf = 0, px = 0, py = 0;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect(); px = (e.clientX - r.left) / r.width; py = (e.clientY - r.top) / r.height;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          el.classList.add('is-tilting');
          el.style.setProperty('--try', ((px - 0.5) * 10).toFixed(2) + 'deg');
          el.style.setProperty('--trx', ((0.5 - py) * 8).toFixed(2) + 'deg');
          el.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
          el.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
        });
      });
      el.addEventListener('pointerleave', function () { el.classList.remove('is-tilting'); el.style.setProperty('--try', '0deg'); el.style.setProperty('--trx', '0deg'); });
    });
  }

  /* ---------- dark panels: grain + pointer light ---------- */
  function live(scope) {
    [].forEach.call((scope || document).querySelectorAll('.scc-gs, .scc-club, .footer'), function (el) {
      if (el.__live) return; el.__live = true;
      el.classList.add('scc-live');
      var grain = document.createElement('i'); grain.className = 'scc-grain'; grain.setAttribute('aria-hidden', 'true');
      var glow = document.createElement('i'); glow.className = 'scc-glow'; glow.setAttribute('aria-hidden', 'true');
      el.insertBefore(glow, el.firstChild); el.insertBefore(grain, el.firstChild);
      if (!fine || reduce) return;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', (e.clientX - r.left) + 'px'); el.style.setProperty('--my', (e.clientY - r.top) + 'px');
        el.classList.add('is-lit');
      });
      el.addEventListener('pointerleave', function () { el.classList.remove('is-lit'); });
    });
  }

  /* ---------- hero: suits drifting up through the felt ---------- */
  function suits() {
    var host = document.querySelector('.scc-deal__bg');
    if (!host || reduce || host.querySelector('.scc-suits')) return;
    var c = document.createElement('canvas'); c.className = 'scc-suits'; c.setAttribute('aria-hidden', 'true'); host.appendChild(c);
    var ctx = c.getContext('2d'); if (!ctx) return;
    var G = ['♠', '♥', '♦', '♣'], P = [], W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2), on = true, running = false;
    function size() { W = host.clientWidth; H = host.clientHeight; c.width = W * dpr; c.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    function spawn(y) { return { x: Math.random() * W, y: y == null ? H + 20 : y, s: 10 + Math.random() * 22, v: 0.15 + Math.random() * 0.35, a: 0.04 + Math.random() * 0.1, r: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.006, g: G[(Math.random() * 4) | 0], w: Math.random() * 6.28 }; }
    size(); var n = Math.round(Math.min(34, W / 40)); for (var i = 0; i < n; i++) P.push(spawn(Math.random() * H));
    window.addEventListener('resize', size, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { on = e[0].isIntersecting; if (on) start(); }).observe(host);
    function start() { if (!running) { running = true; requestAnimationFrame(loop); } }
    function loop() {
      if (!on || document.hidden) { running = false; return; }
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < P.length; i++) {
        var p = P[i]; p.y -= p.v; p.w += 0.01; p.r += p.vr; var x = p.x + Math.sin(p.w) * 12;
        if (p.y < -30) P[i] = spawn();
        ctx.save(); ctx.translate(x, p.y); ctx.rotate(p.r); ctx.globalAlpha = p.a;
        ctx.fillStyle = (p.g === '♥' || p.g === '♦') ? '#e8a08a' : '#f3e4c8';
        ctx.font = p.s + 'px Georgia, serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText(p.g, 0, 0); ctx.restore();
      }
      requestAnimationFrame(loop);
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) start(); });
    start();
  }

  /* ---------- header: a Play link to Game Night (skipped once the menu has one) ---------- */
  function playLink() {
    if (document.querySelector('.header__inline-menu a[href*="/pages/games"]:not(.scc-play-link), .menu-drawer__menu a[href*="/pages/games"]:not(.scc-play-link)')) return;
    var desk = document.querySelector('.header__inline-menu .list-menu--inline');
    if (desk && !desk.querySelector('.scc-play-link')) {
      var last = desk.lastElementChild;
      if (last) {
        var li = document.createElement('li');
        li.innerHTML = '<a href="' + games + '" class="header__menu-item list-menu__item link link--text focus-inset scc-play-link"><span>Play</span><span class="scc-play-link__tag">Live</span></a>';
        desk.appendChild(li);
      }
    }
    var mob = document.querySelector('.menu-drawer__menu');
    if (mob && !mob.querySelector('.scc-play-link')) {
      var li2 = document.createElement('li');
      li2.innerHTML = '<a href="' + games + '" class="menu-drawer__menu-item list-menu__item link link--text focus-inset scc-play-link">Play games <span class="scc-play-link__tag">Live</span></a>';
      mob.appendChild(li2);
    }
  }

  /* ---------- scroll progress + header shadow ---------- */
  function progress() {
    if (document.querySelector('.scc-progress')) return;
    var bar = document.createElement('div'); bar.className = 'scc-progress'; bar.setAttribute('aria-hidden', 'true'); document.body.appendChild(bar);
    var hdr = document.querySelector('.header-wrapper'), tick = false;
    function upd() { tick = false; var h = doc.scrollHeight - window.innerHeight; bar.style.setProperty('--sp', h > 0 ? (window.scrollY / h).toFixed(4) : 0); if (hdr) hdr.classList.toggle('scc-scrolled', window.scrollY > 40); }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  function boot(scope) { try { playLink(); live(scope); tilt(scope); markReveal(scope); /* drifting suits and the scroll bar are off: calmer page */ } catch (e) { /* never block the page */ } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
